import React, { useState, useEffect } from "react";
import { TextField, Box } from "@mui/material";
import SoftTypography from "../../../components/SoftTypography";
import PropTypes from "prop-types";

const EmailFilter = ({
                         title,
                         handleEmailChange,
                         placeholder,
                         emailValue,
                         email,
                         setEmail,
                         clearEmail
                     }) => {
    const [error, setError] = useState("");

    useEffect(() => {
        if (email === "" && error) {
            setError("");
        }
    }, [email]);

    const validateEmail = (value) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(value);
    };

    const handleValidation = () => {
        if (email === "") {
            setError("");
            handleEmailChange(email);
        } else if (!validateEmail(email)) {
            setError("Please enter a valid email address");
            if (emailValue) {
                clearEmail();
            }
        } else {
            setError("");
            handleEmailChange(email);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleValidation();
        }
    };

    return (
        <>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box display="flex" alignItems="center">
                    <SoftTypography
                        variant="h6"
                        mb={0}
                        style={{
                            fontSize: "0.9rem",
                            lineHeight: "normal",
                            padding: "8px"
                        }}
                    >
                        {title}
                    </SoftTypography>
                </Box>
            </Box>

            <TextField
                fullWidth
                variant="outlined"
                placeholder={placeholder}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={handleKeyDown}
                error={Boolean(error)}
                helperText={error}
                sx={{ marginBottom: "16px" }}
            />
        </>
    );
};

EmailFilter.propTypes = {
    title: PropTypes.string,
    handleEmailChange: PropTypes.func,
    placeholder: PropTypes.string,
    emailValue: PropTypes.string,
    email: PropTypes.string,
    setEmail: PropTypes.func,
    clearEmail: PropTypes.func,
};

export default EmailFilter;
